module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (101).1f72a696.jpg";